"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = exports.Icon = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const React = __importStar(require("react"));
const icons_1 = require("./icons");
Object.defineProperty(exports, "Icons", { enumerable: true, get: function () { return icons_1.Icons; } });
// XXX: This is a hack to get around the fact you can't use CSS in any reasonable way to colour non-inlined SVGs.
// 		See https://stackoverflow.com/questions/22252472/how-to-change-the-color-of-an-svg-element
// 		  & use https://codepen.io/sosuke/pen/Pjoqqp to generate filters from hex codes
// TODO: Work out how to use inlined SVGs so we can set the colours with "normal" CSS ...
const colourFilters = {
    white: 'invert(100%) sepia(0%) saturate(7500%) hue-rotate(318deg) brightness(106%) contrast(103%)',
    lightGrey: 'invert(97%) sepia(12%) saturate(4%) hue-rotate(180deg) brightness(112%) contrast(80%)',
    darkGrey: 'invert(17%) sepia(7%) saturate(0%) hue-rotate(220deg) brightness(97%) contrast(89%)',
};
const StyledIcon = styled_1.default.div `
	display: block;
	padding: 0 0 100%;
	position: relative;
	background-color: ${(props) => props.background || 'transparent'};
	border-radius: 50%;

	&::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		width: 65%;
		height: 65%;
		transform: translateX(-50%) translateY(-50%);
		background-image: url(${(props) => icons_1.Icons[props.icon]});
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		${({ colour }) => !!colour && colourFilters[colour] !== undefined ? `filter: ${colourFilters[colour]}` : ''}
	}
`;
const Icon = (props) => props.icon in icons_1.Icons ?
    React.createElement(StyledIcon, Object.assign({}, props))
    : null;
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map